import styled from 'styled-components';

export const EditGuestMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l25};
    `
);

export const EditGuestHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const AddAnotherRoomWrap = styled.div(
    props => `
        padding-top: ${props.theme.spacing.large.l20};
        display: flex;
    `
);

export const AddAnotherText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        font-weight: ${props.theme.font.fontWeight.black};
        text-decoration: none;
        color: ${props.disabled ? props.theme.colors.grey.base : props.theme.colors.blue.base};
        opacity: ${props.disabled ? '0.3' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
        cursor: ${props.disabled ? '' : 'pointer'};

        &:hover{
            color: ${props.theme.colors.blue.base};
        }
    `
);